import React,{ useState, useEffect } from 'react';
import { 
    Menu,
    Button
} from 'antd';

function HardwareSetup( { handleMenuItemClick, openKeys, selectedKeys } ) {

    const getItem = (label, key, icon, children, type) => {
        return {
            key,
            icon,
            children,
            label,
            type,
        };
    }

    const items = [
        getItem('Internet Installation Guide', 'sub1', null, [
            getItem('Cable Modem Set Up', 'modem-setup'),
            getItem('Cable Modem and Connectivity', 'modem-connectivity'),
            getItem('Internet Troubleshooting Tips', 'internet-troubleshooting'),
            getItem('Terms of Service', 'terms-of-service'),
        ]),
        getItem('Mercku Router Installation Guide', 'sub2', null, [
            getItem('Mercku M6 Router Set Up', 'router-setup'),
            getItem('Expand Your Wifi Coverage', 'wifi-coverage'),
        ]),
        getItem('TV Installation Guide', 'sub3', null, [
            getItem('How to Connect Your Set-Top Box', 'stb-setup'),
            getItem('Remote Guide', 'remote-guide'),
            getItem('Setting Up Your Start TV Account', 'tv-account-setup'),
            getItem('Start TV Troubleshooting Tips', 'tv-troubleshooting'),
            getItem('Terms of Service', 'tv-terms-of-service'),
        ]),
        getItem('Digital Home Phone Installation Guide', 'sub4', null, [
            getItem('Voice Adapter Connection', 'voice-adapter-connection')
        ])
    ];

    return (
        <>
            <Menu
                onClick={handleMenuItemClick}
                style={{
                        width: '100%',
                }}
                selectedKeys={ selectedKeys }
                //openKeys={ openKeys }
                mode="inline"
                items={items}
            />
        </>
        
    )
}

export default HardwareSetup